const baseStyle = {};
const defaultProps = {};
export default {
  baseStyle,
  defaultProps
};
//# sourceMappingURL=box.js.map